export default __webpack_public_path__ + "static/media/heroImg2.51a191e9.png";